import components from './components';
import sharedComponents from './sharedComponents';
import models from './models';
import layouts from './layouts';
import validations from './validations';
import meta from './meta';
import presenters from './presenters';
import settings from './settings';

export default {
  translation: {
    components,
    sharedComponents,
    models,
    layouts,
    validations,
    meta,
    presenters,
    settings,
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en/index.js